export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SET_PLASMA_BANNER = 'SET_PLASMA_BANNER';
export const SET_PLASMA_WARNING = 'SET_PLASMA_WARNING';